
  import Vue from 'vue'
  import DeviceSharesTable from '@/components/entities/deviceshare/DeviceSharesTable.vue'
  import DeviceShareCreateDialog from '@/components/entities/deviceshare/DeviceShareCreateDialog.vue'

  import InfoCard from '@/components/misc/InfoCard.vue'

  import DeviceShareService from '@/services/DeviceShareService';
  import { extractErrorMessage } from '@/utils/Util'

  export default Vue.extend({
    name: 'DeviceSharesView',

    components: {
      DeviceSharesTable,
      InfoCard,
      DeviceShareCreateDialog
    },
    data: () => ({
      deviceshares: [] as any,
      dataLoaded: false,
      dataError: false,
      alertText: "",
      alertType: "error",
      filters: {} as any,
    }),
    async created() {
      this.updateDeviceShares();
    },
    watch: {
    },
    methods: {
      onTableReload() {
        this.updateDeviceShares();
      },
      onFiltersUpdate(filters: any) {
        this.filters = filters;
        this.updateDeviceShares();
      },
      onItemUpdate(item: any) {
        this.deviceshares.splice(this.deviceshares.findIndex((prop: any) => prop.uuid === item.uuid), 1);
        this.deviceshares.push(item);
      },
      onItemDelete(item: any) {
        this.deviceshares.splice(this.deviceshares.findIndex((prop: any) => prop.uuid === item.uuid), 1);
      },
      onItemCreation(property: any) {
        this.deviceshares.push(property);
      },
      updateDeviceShares() {
        this.deviceshares = [];
        this.dataLoaded = false;
        
        let params = {};
        Object.assign(params, this.filters);

        DeviceShareService.getAllCollectionPages(params).then((deviceshares: any[]) => {
          this.dataLoaded = true;

          this.deviceshares = deviceshares;
        }).catch((err: any) => {
          console.log(err, err.response);  
          this.alertType = "error";
          this.alertText = extractErrorMessage(err);
          this.dataError = true;      
        });
      }
    },
    computed: {
      currentTenant(): any {
        return this.$root.$store.state.session.selectedTenant.uuid;
      },
      canCreate(): any {
        if (this.$root.$store.state.session.permissions.resources && 'deviceshares' in this.$root.$store.state.session.permissions.resources) {
          return this.$root.$store.state.session.permissions.resources['deviceshares'].includes('POST');
        } else {
          return false;
        }
      },
      lastCreatedAt(): any {
        let occurrences: any = {};
        let sum = 0;

        let pastDate = new Date();
        pastDate.setDate(pastDate.getDate()-7); 

        this.deviceshares.forEach((userObj: any) => {
          let _date = new Date(userObj.createdAt);
          if(_date >= pastDate) {
            let item = _date.getDate() + '-' + _date.getMonth();
            occurrences[item] = (occurrences[item] || 0) + 1;
            sum = sum + 1;
          }
        }, {});

        return sum;
      }
    }
  })
